import { getCurrentStep } from '../store/flow/selectors';
export const hasStepJustBeenCompleted = (state, step) => {
  const currentStep = getCurrentStep(state);
  return step && step === currentStep;
};